import Button from "../Button/Button";
import Divider from "../Divider/Divider";

export default function DeleteListForm({ list, onDelete, onClose }) {
    return (
        <div>
            <h1 className="text-xl font-bold mb-2">
                Delete List
            </h1>
            <Divider />
            <p className="mb-6">
                Are you sure you want to permanently delete <strong>{list.name}</strong>?
            </p>
            <div className="flex justify-end gap-4">
                <Button variant="ghost" onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant="danger"
                    onClick={() => {
                        onDelete(list);
                        onClose();
                    }}
                >
                    Delete List
                </Button>
            </div>
        </div>
    );
}
